import { SortDirection } from '@tanstack/react-table';
import { ChevronDown, ChevronUp } from 'lucide-react';

export const DataTableSortingArrows = ({ isSorted }: { isSorted: SortDirection | false }) => {
  return (
    <span className="ml-2">
      {isSorted === 'asc' && (
        <>
          <ChevronUp className="h-3 w-3" /> <div className="h-3 w-3" />
        </>
      )}

      {isSorted === 'desc' && (
        <>
          <div className="h-3 w-3" />
          <ChevronDown className="h-3 w-3" />
        </>
      )}

      {!isSorted && (
        <>
          <ChevronUp className="h-3 w-3" />
          <ChevronDown className="h-3 w-3" />
        </>
      )}
    </span>
  );
};
